export default __webpack_public_path__ + "bab1877431043af20a77091d950c0f85.jpeg";